<template>
  <div
    class="checkin"
    :style="`background:${bgcolor};padding-top:${banner_list.length>0?'0rem':'10vh'}`"
  >
    <div v-if="banner_list.length>0" class="banner">
      <van-swipe :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="(row, index) in banner_list" :key="index">
          <a :href="row.jumpurl">
            <img :src="row.imgurl" />
          </a>
        </van-swipe-item>
      </van-swipe>
      <svg class="svg" width="100%" height="2.75rem" viewBox="0 0 750 110">
        <g
          id="页面-1"
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
          opacity="0.303713"
        >
          <g
            id="画板-copy-6"
            transform="translate(0.000000, -442.000000)"
            :fill="bgcolor"
            fill-rule="nonzero"
          >
            <path
              d="M0,458.93083 C8.40624224,440.316633 43.6567327,437.04298 105.751471,449.109871 C198.893579,467.210207 258.208903,515.474071 343.284769,523.818784 C427.307426,523.818784 430.968581,489.343703 467.499323,489.061131 C504.030065,488.77856 498.748919,520.08021 573.742456,520.08021 C622.563421,520.08021 637.122326,484.187611 679.002038,464.681332 C706.921846,451.677146 730.703561,455.454477 750.347182,476.013327 L750.347182,551.343703 L0,551.343703 L0,458.93083 Z"
              id="矩形"
            />
          </g>
        </g>
      </svg>
      <svg class="svg" width="100%" height="2.25rem" viewBox="0 0 750 90">
        <g
          id="页面-1"
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
          opacity="0.339285714"
        >
          <g
            id="画板-copy-6"
            transform="translate(0.000000, -461.000000)"
            :fill="bgcolor"
            fill-rule="nonzero"
          >
            <path
              d="M0,506.126356 C50.1079997,513.58899 93.2135338,514.68639 129.316602,509.418556 C182.711536,501.627649 200.44015,457.697923 285.874793,461.185604 C330.965479,463.026332 388.649031,512.74981 433.268115,516.475339 C517.944899,523.545538 523.52861,487 577.447617,487 C611.093823,487 618.033015,512.112924 676.462225,516.475339 C718.839134,519.639265 743.400556,516.189604 750.146492,506.126356 L750.146492,551.126356 L0,551.126356 L0,506.126356 Z"
              id="矩形"
            />
          </g>
        </g>
      </svg>
    </div>
    <div class="body">
      <div class="top">
        <van-search
          v-model="keyword"
          :placeholder="placeholder"
          show-action
          shape="round"
          @search="onSearch"
        >
          <div slot="action" @click="onSearch">
            <van-button :loading="loading" type="info" round size="small" hairline>搜索</van-button>
          </div>
        </van-search>
      </div>
      <div class="center"></div>
      <div class="bottom">
        <div v-if="list.length==0" class="none">
          <img src="../../assets/none.png" />
          <div class="_line">暂无搜索记录</div>
        </div>
        <div v-else class="list">
          <van-cell
            v-for="(item, index) in list"
            :key="index"
            :title="item.name"
            is-link
            :to="{name: 'c_detail',params: {id: item.id}, query: $route.query}"
            :value="item.number||''"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCheckinConfig, searchCheckin, getBanners } from "../../libs/api";

export default {
  data() {
    return {
      keyword: "",
      bgcolor: "f4f4f4",
      loading: false,
      placeholder: "输入关键词搜索",
      list: [],
      banner_list: []
    };
  },
  mounted() {
    this.get_checkin_config();
    this.get_banners();
  },
  methods: {
    get_checkin_config() {
      getCheckinConfig({ checkinid: this.$route.query.checkinid }).then(r => {
        if (r.data.configname) {
          document.title = r.data.configname;
        }
        this.placeholder = r.data.placeholder;
        if (r.data.backgroundimage) {
          this.bgcolor = `url(${r.data.backgroundimage}) no-repeat center center/cover`;
        } else {
          if (r.data.backgroundcolor) {
            this.bgcolor = `#${r.data.backgroundcolor}`;
          } else {
            this.bgcolor = "#f4f4f4";
          }
        }
      });
    },
    onSearch() {
      this.loading = true;
      if (!this.keyword) {
        this.loading = false;
        this.list = [];
        return;
      }
      searchCheckin({
        keywords: this.keyword,
        checkinid: this.$route.query.checkinid
      }).then(r => {
        this.loading = false;
        this.list = r.data;
      });
    },
    get_banners() {
      getBanners({
        position: 3,
        positionid: this.$route.query.checkinid
      }).then(r => {
        this.banner_list = r.data;
      });
    }
  }
};
</script>

<style scoped>
.checkin >>> .van-cell__value {
  text-align: right;
}
</style>

<style lang="less" scoped>
.checkin {
  background: #f4f4f4;
  min-height: 100vh;
  .banner {
    height: 8.8rem;
    margin-bottom: 1.2rem;
    font-size: 0;
    position: relative;
    .svg {
      position: absolute;
      bottom: -10px;
      left: 0;
      right: 0;
      pointer-events: none;
    }
    a {
      width: 100%;
      height: 100%;
      img {
        width: 100%;
        object-fit: contain;
      }
    }
  }
  .body {
    box-sizing: border-box;
    padding: 0rem 0.8rem 1.2rem;
    .top {
      padding: 1rem 0.4rem;
      border-top-right-radius: 0.6rem;
      border-top-left-radius: 0.6rem;
    }
    .bottom {
      min-height: 13rem;
      padding: 1rem 0.8rem;
      border-bottom-right-radius: 0.6rem;
      border-bottom-left-radius: 0.6rem;
    }
    .top,
    .bottom {
      background: #fff;
    }
    .center {
      width: 100%;
      height: 19px;
      background: url(../../assets/center.png) no-repeat center center;
      background-size: 100% 100%;
    }
    .list {
      background: #fff;
    }
    .none {
      padding-top: 0rem;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      img {
        width: 6.8rem;
      }
      ._line {
        display: flex;
        align-items: center;
        margin-top: 1.5rem;
        font-size: 0.7rem;
        color: #cccccc;
        &::after {
          content: " ";
          display: block;
          margin-left: 1rem;
          width: 4rem;
          height: 0.05rem;
          background: #ccc;
        }
        &::before {
          content: " ";
          display: block;
          margin-right: 1rem;
          width: 4rem;
          height: 0.05rem;
          background: #ccc;
        }
      }
    }
  }
}
</style>
